<template>
    <div class="sustainable-component admin-view-log-department">
        <!--<div class="bg-success mb-3 p-3 rounded">vue admin-view-log-department</div>-->
        <div class="container-fluid p-0 mt-3">
            <div class="row">
                <div class="col-6">
                    <v-text-field bg-color="white" type="date" label="Startdatum" v-model="startDate" variant="outlined"></v-text-field>
                </div>
                <div class="col-6">
                    <v-text-field bg-color="white" type="date" label="Slutdatum" v-model="endDate" variant="outlined"></v-text-field>
                </div>
            </div>
            <div class="row table-space">
                <div class="col-12">
                    <b>Totalt {{logentries.length}} logginlägg</b>
                    <table class="mt-2 table table-light table-hover table-striped" cellspacing="0" cellpadding="8" border="0" style="border-collapse:collapse">
                        <thead>
                            <tr>
                                <th class="col-2">Datum</th>
                                <th class="col-4">Aktivitet</th>
                                <th class="col-2">IP-adress</th>
                                <th class="col-2">Användare</th>
                                <th class="col-2">Senast inloggad</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(item, index) in getFiltered(currentindex)" :key="index">
                                <td>{{item.Datum}}</td>
                                <td>{{item.Activity}}</td>
                                <td>{{item.IPAddres}}</td>
                                <td>{{item.User}}</td>
                                <td>{{item.LastLoggedIn}}</td>
                            </tr>
                            <tr v-if="logentries.length > currentindex">
                                <td colspan="5">
                                    <a href="javascript:void(0)" @click="currentindex += 50">Läs mer</a>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>
        <v-snackbar :timeout="2000" v-model="showSnackBar" color="success">
            {{snackbarMessage}}
        </v-snackbar>
        <v-snackbar :timeout="2000" v-model="showErrorMessageSnackBar" color="error">
            {{errorMessage}}
        </v-snackbar>
        <common-spinner v-bind:loading="loading > 0"></common-spinner>
    </div>
</template>


<script>

    import AdminService from "../../Services/AdminService";
    import CommonSpinner from '../../common/common-spinner.vue'
    import moment from 'moment'

    export default {

        name: 'admin-view-log-department',
        props: {

        },
        components: {
            CommonSpinner,
        },
        methods: {
            async getLogEntries() {
                this.loading++;
                try {
                    this.logentries = await AdminService.getLogEntriesFromDepartmentByDate(this.startDate, this.endDate);
                }
                catch (error) {
                    this.displayErrorSnackBar("Ett oväntat fel har inträffat.")
                }
                this.loading--;
            },
            getFiltered(currentindex) {
                return this.logentries.slice(0, currentindex)
            },
            displaySnackBar(message) {
                this.snackbarMessage = message;
                this.showSnackBar = true;
            },
            displayErrorSnackBar(message) {
                this.errorMessage = message;
                this.showErrorMessageSnackBar = true;
            },
        },

        data() {
            return {
                currentindex: 50,
                logentries: [],
                startDate: "",
                endDate: "",
                loaded: false,
                loading: 0,
                showSnackBar: false,
                snackbarMessage: null,
                showErrorMessageSnackBar: false,
                errorMessage: null,
            };
        },
        watch: {
            startDate: function () {
                if (this.loaded == true)
                    this.getLogEntries();
            },
            endDate: function () {
                if (this.loaded == true)
                    this.getLogEntries();
            },
        },
        async mounted() {
            this.startDate = (moment().subtract(29, 'd')).format("YYYY-MM-DD");
            this.endDate = moment().add(1, 'days').format("YYYY-MM-DD");
            await this.getLogEntries();
            this.loaded = true;
        },
        setup() {
            return {}
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>